import ClinicsPanel from "lib/components/common/dashboard/clinics-panel";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import DashboardLayout from "lib/components/layouts/dashboard";
import { Col, Row } from "react-bootstrap";
import SimpleCard from "lib/components/common/simple-card";
import SimpleDataTable from "lib/components/common/simple-data-table";
import {
  CLINIC_PATIENTS_INCOME_COLUMNS,
  CLINIC_PRACTITIONERS_INCOME_COLUMNS,

} from "lib/constants/table-columns";
import { useEffect, useMemo, useState } from "react";
import useClinics from "lib/hooks/useClinics";
import { DEFAULT_CLINICS_INCOME } from "lib/constants/default-values";
import { formatCurrency } from "lib/utils/util";
import FlexBox from "lib/components/common/flex-box";

const BreadcrumbItems = [
  {
    label: "Payments",
    path: PAGE_ROUTES.ADMIN.Dashboard,
  },
] as BreadcrumbItem[];

const AdminPaymentsPage = () => {
  const {
    getClinicIncome,
    loading: clinicsLoading,
    error: clinicsError,
  } = useClinics();

  const [selectedClinicId, setSelectedClinicId] = useState<string>("");
  const [clinicIncomeDetails, setClinicIncomeDetails] = useState<ClinicIncome>(
    DEFAULT_CLINICS_INCOME
  );

  useEffect(() => {
    if (selectedClinicId) {
      getClinicIncome(selectedClinicId, (clinicIncome) =>
        setClinicIncomeDetails(clinicIncome)
      );
    }
  }, [selectedClinicId]);

  const handleClinicChange = (selectedClinic: Clinic) => {
    setSelectedClinicId(selectedClinic?.id);
  };

  const subscriptionsTotal = useMemo(() => {
    return (
      clinicIncomeDetails?.subscriptions?.reduce(
        (total, subscription) => total + subscription.totalCost,
        0
      ) || 0
    );
  }, [clinicIncomeDetails?.subscriptions]);

  const patientsTotal = useMemo(() => {
    return (
      clinicIncomeDetails?.patientBookings?.reduce(
        (total, booking) => total + Number(booking.totalCost),
        0
      ) || 0
    );
  }, [clinicIncomeDetails?.patientBookings]);

  return (
    <DashboardLayout breadcrumbItems={BreadcrumbItems}>
      <ClinicsPanel
        onClinicChange={handleClinicChange}
        isLoading={clinicsLoading}
        error={clinicsError}
      >
        <Row>
          <Col xs={6}>
            <SimpleCard
              title="Patients"
              subtitle="Patient Payments"
              action={<h4>{formatCurrency(patientsTotal ?? 0)}</h4>}
            //actionSubtitle="Total Income from Patients"
            >
              <SimpleDataTable
                columns={CLINIC_PATIENTS_INCOME_COLUMNS}
                data={clinicIncomeDetails?.patientBookings ?? []}
              />
            </SimpleCard>
          </Col>
          <Col xs={6}>
            <SimpleCard
              title="Subscriptions"
              subtitle="Practitioner Subscription Payments"
              action={<h4>{formatCurrency(subscriptionsTotal ?? 0)}</h4>}
            //actionSubtitle="Total Income from Subscriptions"
            >
              <SimpleDataTable
                columns={CLINIC_PRACTITIONERS_INCOME_COLUMNS}
                data={clinicIncomeDetails?.subscriptions ?? []}
              />
            </SimpleCard>
          </Col>
        </Row>
      </ClinicsPanel>
    </DashboardLayout>
  );
};

export default AdminPaymentsPage;
